import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { getConnection, getErrorMessage, hideSpinner, ignoreSpecialCharacters, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { arrayNotEmpty } from 'class-validator';
import { ActivatedRoute } from '@angular/router';
import { PropertiesService } from '../../services/properties.service';
import { SerProperty } from '../../models/property.model';

@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss']
})
export class PropertiesComponent implements OnInit {

  properties: SerProperty[] = []
  selectedProperty: SerProperty | undefined

  form: FormGroup
  icons: string[] = []

  constructor(
    private propertiesService: PropertiesService,
    private helpers: HelpersService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
  ) {
    this.form = this.formBuilder.group({
      id: [""],
      estado: ["", [Validators.required]],
      key: ["", [Validators.required]],
      valor: ["", [Validators.required]],
    })
    this.resetForm()
  }

  async ngOnInit() {
    const data = this.activatedRoute.snapshot.data
    if (data.title) {
      this.helpers.setTitle(data.title);
    }
    showSpinner()
    await this.getAllProperties()
    hideSpinner()
  }

  resetForm(selectedProperty: SerProperty | undefined = undefined) {
    this.selectedProperty = selectedProperty
    if (selectedProperty == undefined) {
      this.selectedProperty = undefined
      this.form.reset()
    } else {
      this.form.get("id")?.setValue(selectedProperty?.id)
      this.form.get("estado")?.setValue(selectedProperty?.estado)
      this.form.get("key")?.setValue(selectedProperty?.key)
      this.form.get("valor")?.setValue(selectedProperty?.valor)
    }
  }

  async getAllProperties() {
    showSpinner()
    try {
      const result = await this.propertiesService.findAll({}, true)
      if (result.success) {
        this.properties = result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
    }
    hideSpinner()
  }
  async getOneProperty(key: string) {
    try {
      const result = await this.propertiesService.findOne(key)
      if (result.success) {
        return result.data
      } else {
        this.helpers.notifications.errorMessage(result.message)
        return null
      }
    } catch (error) {
      const message = getErrorMessage(error)
      this.helpers.notifications.errorMessage(message)
      return null
    }
  }

  async selectProperty(selected: SerProperty[]) {
    showSpinner()
    if (arrayNotEmpty(selected) && selected[0].key) {
      let newProperty: SerProperty | undefined = undefined
      newProperty = await this.getOneProperty(selected[0].key)
      if (newProperty?.key) {
        this.resetForm(newProperty)
      }
    }
    hideSpinner()
  }

  async create() {
    showSpinner()
    if (this.form.valid) {
      try {
        const result = await this.propertiesService.create(this.form.value)
        if (result.success) {
          await this.getAllProperties()
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Todos los campos son obligatorios")
    }
  }
  ignoreSpecialCharactersVoid(controlName: string, value: string) {
    let hola = ignoreSpecialCharacters(value)
    this.form.get(controlName)?.setValue(hola)
    return hola
  }
  async modify() {
    showSpinner()
    if (this.form.valid && this.selectedProperty && this.selectedProperty.id) {
      try {
        const result = await this.propertiesService.update(this.form.value, {
          id: this.selectedProperty?.id
        })
        if (result.success) {
          await this.selectProperty([{ key: result.data.current[0].key }])
          this.getAllProperties()
          this.helpers.notifications.successMessage(result.message)
        } else {
          this.helpers.notifications.errorMessage(result.message)
        }
        hideSpinner()
      } catch (error) {
        hideSpinner()
        const message = getErrorMessage(error)
        this.helpers.notifications.errorMessage(message)
      }
    } else {
      hideSpinner()
      this.helpers.notifications.errorMessage("Todos los campos son obligatorios")
    }
  }

  print(value) {
    return JSON.stringify(value)
  }
}